import leboQuery from './index.vue'

leboQuery.install = function (Vue) {
  Vue.component(leboQuery.name, leboQuery)
}

export default leboQuery
